module.exports = __webpack_public_path__ + "static/media/App.7a457429.png";